<!-- <p>year-performance works!</p> -->


<mat-toolbar  class="background-color-green">
    <!-- <a href="#" routerLink="/">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <mat-icon>account_circle</mat-icon>
        
    </a> -->
    <a routerLink="/">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>
    <!-- <button>
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
    </button> -->
    
    <!-- <span class="cursor-pointer" routerLink="/">Angular Identity SPA</span> -->
    <!-- <span class="text-color-white">My Annual Performance</span> -->
    <span class="text-color-white">{{ 'ml_143974' | translate }}</span>
    <!-- 143974 -->
    
</mat-toolbar>

<mat-toolbar-row>
    <!-- <span class="font-weight-600 text-color-blue font-size-22px">Fiscal Year {{date.toISOString()!.split('T')[0].substring(0, 4)}}</span> -->
    <span class="font-weight-600 text-color-blue font-size-22px">{{ 'ml_144012' | translate }} {{date.toISOString()!.split('T')[0].substring(0, 4)}}</span>
    <!-- 144012 -->
</mat-toolbar-row>

<div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white;">
    <mat-spinner [color]="color"></mat-spinner>
</div>

<mat-accordion class="example-headers-align">
    <mat-list>
        

        <!-- @for (PerformanceYearSection of PerformanceYearSectionArray; track PerformanceYearSection) {
            <mat-list-item>
                <span class="font-weight-600">{{PerformanceYearSection.name}}</span>
            </mat-list-item>
            @if(PerformanceYearSection.kpiCategoryType === 'I'){
                @for (kpiPerformance of PerformanceYearSection.kpiPerformances; track kpiPerformance) {
                    <mat-expansion-panel hideToggle disabled>
                    <mat-expansion-panel-header style="color: rgba(0,0,0,0.86);">
                        <mat-panel-title class="flex-basis-200px">
                            {{kpiPerformance.kpiName}}
                        </mat-panel-title>
                        <mat-panel-description>
                            {{kpiPerformance.total === 1 ? 'Yes' : 'No'}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                        
                    </mat-expansion-panel>
                }
            }
            @else {
                @for (kpiPerformance of PerformanceYearSection.kpiPerformances; track kpiPerformance) {
                    <mat-expansion-panel disabled hideToggle>
                    <mat-expansion-panel-header  style="color: rgba(0,0,0,0.86);">
                        <mat-panel-title class="flex-basis-200px">
                            {{kpiPerformance.kpiName}}
                        </mat-panel-title>
                        <mat-panel-description>
                            {{kpiPerformance.total}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                        
                    </mat-expansion-panel>
                }
            }
            
        } -->

        @for (yearPerformanceObject of yearPerformanceObjectArray; track yearPerformanceObject) {
            <mat-list-item>
                <!-- <span class="font-weight-600 text-color-blue">{{yearPerformanceObject.categoryName}}</span> -->
                <span class="font-weight-600 text-color-blue">{{ yearPerformanceObject.translation_Id | translate }}</span>
            </mat-list-item>
            @if(yearPerformanceObject.catergoryId === 'I'){
                @for (groupedKpi of yearPerformanceObject.kpis; track groupedKpi) {
                    <!-- <mat-expansion-panel hideToggle disabled> -->
                    <mat-expansion-panel hideToggle disabled>
                        <!-- <mat-expansion-panel-header style="color: rgba(0,0,0,0.86);"> -->
                        <mat-expansion-panel-header style="color: rgba(0,0,0,0.86); ">
                            <mat-panel-title class="flex-basis-200px text-color-green" style="color: #009947;">
                                <!-- {{groupedKpi.kpiName}} -->
                                {{ groupedKpi.translation_Id  | translate }}
                            </mat-panel-title>
                            <mat-panel-description class="text-color-blue" style="color: #00BFFF;">
                                <!-- {{groupedKpi.kpiResults.length === 0 ? 'No' : groupedKpi.kpiResults[0].total === 1 ? 'Yes' : 'No'}} -->
                                {{groupedKpi.kpiResults.length === 0 ? no : groupedKpi.kpiResults[0].total === 1 ? yes : no}}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                            
                        </mat-expansion-panel>
                }
            }
            @else {
                @for (groupedKpi of yearPerformanceObject.kpis; track groupedKpi) {
                    <mat-expansion-panel  hideToggle disabled>
                        <mat-expansion-panel-header  style="color: rgba(0,0,0,0.86); ">
                            <mat-panel-title class="flex-basis-200px text-color-green" style="color: #009947;">
                                <!-- {{groupedKpi.kpiName}} -->
                                {{ groupedKpi.translation_Id  | translate }}
                            </mat-panel-title>
                            <mat-panel-description class="text-color-blue" style="color: #00BFFF;">
                                {{groupedKpi.kpiResults.length === 0 ? 0 : groupedKpi.kpiResults[0].total}}
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                            
                        </mat-expansion-panel>
                }
            }
        }

    </mat-list>
</mat-accordion>
